/* @flow */

import React from 'react';
import styled from 'styled-components';

const CanvasContainer = styled.div`
  cursor: none;
  height: 100%;
  overflow: hidden;

  ${props =>
    !props.isVisible &&
    `
    display: none;
  `};
`;

const CanvasElm = styled.canvas`
  height: 100%;
`;

type State = {
  elm: *,
};

class Canvas extends React.Component<*, State> {
  elm = null;

  render() {
    return (
      <CanvasContainer {...this.props}>
        <CanvasElm innerRef={e => (this.elm = e)} />
      </CanvasContainer>
    );
  }
}

export default Canvas;



// WEBPACK FOOTER //
// ./src/Canvas.js